import { LoadingOverlay as SharedLoadingOverlay, type LoadingOverlayProps as SharedLoadingOverlayProps } from "../../../../../shared/frontend/components/LoadingOverlay";
import type { LocalizedText } from "../app/i18n/i18n";
import { useI18n } from "../app/i18n/useI18n";
export type { LoadingOverlayScope } from "../../../../../shared/frontend/components/LoadingOverlay";
type LoadingOverlayProps = Omit<SharedLoadingOverlayProps, "message"> & { message?: LocalizedText };

export function LoadingOverlay(props: LoadingOverlayProps) {
  const { text } = useI18n();
  return <SharedLoadingOverlay {...props} message={props.message ? text(props.message) : undefined}
    loadingLabel={props.loadingLabel ?? text("Loading…")}
    screenTopInset={props.screenTopInset ?? "var(--mu-desktop-overlay-top, var(--critical-issue-banner-height, 0px))"} />;
}
